<template>
    <svg
        fill="none"
        viewBox="0 0 32 32"
        height="18"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            clip-rule="evenodd"
            fill="rgb(var(--v-theme-fontLight))"
            fill-rule="evenodd"
        >
            <path
                d="m4.25 7c0-.41421.33579-.75.75-.75h22c.4142 0 .75.33579.75.75v15c0 .4641-.1844.9092-.5126 1.2374s-.7733.5126-1.2374.5126h-5c-.4641 0-.9092-.1844-1.2374-.5126s-.5126-.7733-.5126-1.2374v-2.25h-6.5v6.25c0 .4641-.1844.9092-.5126 1.2374s-.7733.5126-1.2374.5126h-5c-.46413 0-.90925-.1844-1.23744-.5126s-.51256-.7733-.51256-1.2374zm1.5.75v18.25c0 .0663.02634.1299.07322.1768.04689.0469.11047.0732.17678.0732h5c.0663 0 .1299-.0263.1768-.0732s.0732-.1105.0732-.1768v-7c0-.4142.3358-.75.75-.75h8c.4142 0 .75.3358.75.75v3c0 .0663.0263.1299.0732.1768s.1105.0732.1768.0732h5c.0663 0 .1299-.0263.1768-.0732s.0732-.1105.0732-.1768v-14.25z"
            />
            <path
                d="m4.25 15c0-.4142.33579-.75.75-.75h7c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-7c-.41421 0-.75-.3358-.75-.75z"
            />
            <path
                d="m12 6.25c.4142 0 .75.33579.75.75v12c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-12c0-.41421.3358-.75.75-.75z"
            />
            <path
                d="m19.25 15c0-.4142.3358-.75.75-.75h7c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-7c-.4142 0-.75-.3358-.75-.75z"
            />
            <path
                d="m20 6.25c.4142 0 .75.33579.75.75v12c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-12c0-.41421.3358-.75.75-.75z"
            />
        </g>
    </svg>
</template>
